import { render, staticRenderFns } from "./SuspendCountry.vue?vue&type=template&id=7d4a7c9e&"
import script from "./SuspendCountry.vue?vue&type=script&lang=js&"
export * from "./SuspendCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports